import { redirect, type RouteObject } from "react-router-dom";
import AppError from "../app-error";
import CustomersList, { listLoader } from "./List";
import CustomersDetail, { detailLoader } from "./Detail";
import CustomersAgeing, { ageingLoader } from "./Ageing";
import CustomersDedupe, { dedupeLoader } from "./Dedupe";
import CustomersTradeTerms, { tradeTermsLoader } from "./TradeTerms";
import NewsletterSubscribers, { newsletterLoader } from "./Newsletter";

export const customersRoutes: RouteObject[] = [
  { path: "customers", Component: CustomersList, loader: listLoader, errorElement: <AppError /> },
  { path: "customers/ageing", Component: CustomersAgeing, loader: ageingLoader, errorElement: <AppError /> },
  { path: "customers/dedupe", Component: CustomersDedupe, loader: dedupeLoader, errorElement: <AppError /> },
  // FIN-03: "Duplicate records" is the label, "duplicates" the more guessable URL — redirected
  // rather than left to fall through to `customers/:customerNumber` below, which read it as a customer number and
  // 404'd against the API instead of the router.
  { path: "customers/duplicates", loader: () => redirect("/customers/dedupe") },
  { path: "customers/trade-terms", Component: CustomersTradeTerms, loader: tradeTermsLoader, errorElement: <AppError /> },
  { path: "customers/newsletter", Component: NewsletterSubscribers, loader: newsletterLoader, errorElement: <AppError /> },
  { path: "customers/:customerNumber", Component: CustomersDetail, loader: detailLoader, errorElement: <AppError /> },
];
